import { createContext, useContext, useEffect, useState } from "react"
import { limpaAudio, showNotify, tocarAudio } from "../../Utils/Utils"
import moment from 'moment'

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { WebSocketContext } from "../WebSocket/WebSocketContext"
import { LogadoContext } from "../LogadoContext/LogadoContext"
import { TimersContext } from "../Timers/TimersContext"
import { UserContext } from '../UserContext/UserContex'
import { ChangeComponentContext } from "../ChangeComponentContext/ChangeComponentContext"

global.eventosNovos = []

export const EventosContext = createContext()

export const EventosProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    const { user } = useContext(UserContext)

    LogInit('EventosContext', 'contexto')

    const [eventosNA, setEventosNA] = useState([]) // Não atendidos
    const [eventosEA, setEventosEA] = useState([]) // Atendidos
    const [eventosEE, setEventosEE] = useState([]) // Em Espera
    const [eventosEO, setEventosEO] = useState([]) // Em Obs

    const modeloEventoSelecionado = {
        condominio: '',
        obs_fechamento: '',
        cor: '',
        data: '',
        descricao: '',
        entrada: '',
        equipe: '',
        evento: '',
        id: '',
        id_central: '',
        prioridade: '',
        procedimento: '',
        som: '',
        status: '',
        usuario: '',
        usuario_tratando: {
            id: '',
            nome: '',
            img_perfil: ''
        },
        cameras: [],
        agrupados: ''
    }

    const { addRoute, sendWs } = useContext(WebSocketContext)
    const { logado } = useContext(LogadoContext)
    const { addTimer, rmTimer } = useContext(TimersContext)
    const { changeShowComponent, showComponent } = useContext(ChangeComponentContext)

    const [eventoSelecionado, setEventoSelecionado_] = useState(() => modeloEventoSelecionado)
    initialEventoSelecionado()

    const updateEventoSelecionado = (atualizacoes) => {
        const eventoSelecionadoAux = { ...eventoSelecionado }
        for (const prop in atualizacoes) {
            eventoSelecionadoAux[prop] = atualizacoes[prop]
        }
        setEventoSelecionado(eventoSelecionadoAux)
    }

    useEffect(() => {
        if (logado) {
            addRoute('getAllEventosTela', allEventosTela)
            addRoute('novoEvento', novoEventoNA)
            addRoute('getEvento', setInfosEventoTela)
            addRoute('mudarStatusEvento', mudarStatusEvento)
            addRoute('finalizarEvento', finalizarEventoResp)
        }
    }, [logado])

    function initialEventoSelecionado() {
        let ev_sl = sessionStorage.getItem('o_mo_ev_selected')
        try {
            ev_sl = (ev_sl ? JSON.parse(ev_sl) : modeloEventoSelecionado)
        } catch (e) {
            ev_sl = modeloEventoSelecionado
            console.log('Erro ao setar evento selecionado. ', e)
        }

        return ev_sl
    }

    const setEventoSelecionado = (ev) => {
        try {
            sessionStorage.setItem('o_mo_ev_selected', JSON.stringify(ev))
        } catch (e) {
            console.log('Erro ao setar o_mo_ev_selected no storage. ', e)
        }

        setEventoSelecionado_(ev)

        if (showComponent == 'ocorrencias-tratarEvento') {
            changeShowComponent('ocorrencias-tratarEvento')
        } else if (((ev.evento == 'OVIS' || ev.evento == 'OINI') && ev.mostrar_tela_visitante) || showComponent == 'visitantes-tratarEvento') {
            changeShowComponent('visitantes-tratarEvento')
        } else if (ev.evento == 'ONRV') {
            changeShowComponent('ronda-tratarEvento')
        } else if (isBeNuvemEvent(ev.evento)) {
            changeShowComponent('imgEvento-tratarEvento')
        } else {
            changeShowComponent('abaWeb-tratarEvento')
        }
    }

    const isBeNuvemEvent = (evento) => {
        if (!evento) { return false }
        const eventos_benuvem = ['BEDH', 'BEPP', 'BEAP', 'BEDC', 'BEPC', 'BEDM', 'BEPM', 'BEON', 'BEOF']
        return eventos_benuvem.includes(evento)
    }

    const getLocalEventoSelecionado = () => {
        return JSON.parse(sessionStorage.getItem('o_mo_ev_selected'))
    }

    const finalizarEvento = (parans) => {
        let { id, observacao, id_hashtag, notificacoes } = parans

        id_hashtag = (!id_hashtag ? false : id_hashtag)
        notificacoes = (!notificacoes ? false : notificacoes)

        sendWs('finalizarEvento', { id, observacao, id_hashtag, notificacoes })
    }

    const finalizarEventoResp = (msg) => {
        const { evento } = msg.data
        limpaAudio(evento.id)

        removerEvento(evento)
        if (evento.usuario_fechamento == user.id) {
            showNotify('success', 'Evento finalizado com sucesso!')
        }
    }

    const addEventoNA = (evento) => {
        if (!Object.prototype.hasOwnProperty.call(evento, "data") ||
            !Object.prototype.hasOwnProperty.call(evento, "entrada") ||
            !Object.prototype.hasOwnProperty.call(evento, "evento") ||
            !Object.prototype.hasOwnProperty.call(evento, "id") ||
            !Object.prototype.hasOwnProperty.call(evento, "id_central") ||
            !Object.prototype.hasOwnProperty.call(evento, "usuario")
        ) {
            return false
        }

        setEventosNA(oldArray => [...oldArray, evento])
    }

    const novoEventoNA = (msg) => {
        let evento = msg.data.evento
        if (evento.tocar_som && evento.tocar_som.length > 1) {
            tocarAudio(evento.tocar_som, evento.id)
        }
        global.eventosNovos.push(evento.id)
        addEventoNA(evento)
    }

    const addEventoEA = (evento) => {
        if (!Object.prototype.hasOwnProperty.call(evento, "data") ||
            !Object.prototype.hasOwnProperty.call(evento, "entrada") ||
            !Object.prototype.hasOwnProperty.call(evento, "evento") ||
            !Object.prototype.hasOwnProperty.call(evento, "id") ||
            !Object.prototype.hasOwnProperty.call(evento, "id_central") ||
            !Object.prototype.hasOwnProperty.call(evento, "usuario")
        ) {
            return false
        }

        limpaAudio(evento.id, 1)

        setEventosEA(oldArray => [...oldArray, evento])
    }

    const addEventoEE = (evento) => {
        setEventosEE(oldArray => [...oldArray, evento])
    }

    const addEventoEO = (evento) => {
        setEventosEO(oldArray => [...oldArray, evento])
    }

    const mudarStatusEvento = (msg) => {
        const { evento } = msg.data

        if (evento.statusAnterior == 1) {
            limpaAudio(evento.id, 1)
        }

        if (evento.statusAnterior == 2 && evento.statusAnterior == evento.status) {
            setEventosEA(current => {
                for (const i in current) {
                    if (current[i].id == evento.id) {
                        current[i] = evento
                        break
                    }
                }
                return current
            })
            return
        }

        const funcRemove = definirFuncaoEvento(evento.statusAnterior)
        const funcAdd = definirFuncaoEvento(evento.status)

        // Chama a função de alterar o estado de acordo com o switch a cima
        if (funcRemove && typeof funcRemove == "function") {
            funcRemove((current) =>
                current.filter((ev) => ev.id !== evento.id)
            )
        }

        if (funcAdd && typeof funcAdd == "function") {
            // add event from  Em atendimento
            funcAdd(oldArray => [...oldArray, evento])
        }
        let eventoSel = getLocalEventoSelecionado()
        if ((evento.usuario_tratando != undefined && evento.usuario_tratando.id == user.id) || (eventoSel && evento.id == eventoSel.id)) {
            /* necessário atualizar o evento selecionado, pois mudou o status e status_anterior */
            setEventoSelecionado(evento)
        }
    }

    const allEventosTela = (msg) => {
        limparListasEventos()
        const { status, eventos } = msg.data
        if (status) {
            for (const evento of Object.values(eventos)) {
                if (evento.status == 1) {
                    addEventoNA(evento)
                } else if (evento.status == 2) {
                    addEventoEA(evento)
                } else if (evento.status == 3) {
                    addEventoEE(evento)
                } else if (evento.status == 4) {
                    addEventoEO(evento)
                }
            }
        }
    }

    const limparListasEventos = () => {
        setEventosNA([])
        setEventosEA([])
        setEventosEE([])
        setEventosEO([])
    }

    const setInfosEventoTela = (msg) => {
        const status = msg.data.status
        const evento = msg.data.evento
        if (!status || status === "error") {
            return false
        } else {
            evento.id_hashtag = (!evento.id_hashtag ? 0 : evento.id_hashtag)
            setEventoSelecionado(evento)
            addTimer('timerEventoSelecionado', moment(moment.utc(evento.data).format('YYYY/MM/DD HH:mm:ss')).format('X'))
        }
    }

    const setInfosEvento = (id_evento) => {
        sendWs('getEvento', { id: id_evento })
    }

    const definirFuncaoEvento = (statusEvento) => {
        switch (statusEvento) {
            case 1:
                return setEventosNA
            case 2:
                return setEventosEA
            case 3:
                return setEventosEE
            case 4:
                return setEventosEO
        }
    }

    const removerEvento = (evento) => {
        const funcaoRemoverEvento = definirFuncaoEvento(evento.status)

        removerEventoSelecionado(evento)

        if (typeof funcaoRemoverEvento == 'function') {
            funcaoRemoverEvento(current => {
                return current.filter(eventoAux => eventoAux.id !== evento.id)
            })
        }
    }

    /**
     * Tira a seleção do evento. Caso o parâmetro de evento fechado seja recebido, a função valida se o ev fechado é do usuário
     * @param { {id, usuario_fechamento} } ev_fechado
     */
    const removerEventoSelecionado = (ev_fechado) => {
        let ev_sl = JSON.parse(sessionStorage.getItem('o_mo_ev_selected') || '{}')
        sessionStorage.removeItem('o_mo_ev_selected')
        rmTimer('timerEventoSelecionado', false)
        if (ev_fechado) {
            if (ev_fechado.id == ev_sl.id) {
                setEventoSelecionado(modeloEventoSelecionado)
            }
        } else {
            setEventoSelecionado(modeloEventoSelecionado)
        }
    }

    const updateObsIframe = (msgObs, msgHist) => {
        msgObs = `${moment().format('HH:mm:ss')} - ${user.nome}: ${msgObs}`
        msgHist = `${msgHist}`
        if (eventoSelecionado.id && user.id == eventoSelecionado.usuario_tratando.id && eventoSelecionado.status == 2) {
            let novaObs = eventoSelecionado.obs_fechamento ? eventoSelecionado.obs_fechamento + `\n${msgObs}` : msgObs
            updateEventoSelecionado({ obs_fechamento: novaObs })
            sendWs('gravarHistorico', { id: eventoSelecionado.id, historico: msgHist })
            sendWs('gravarObservacao', { id: eventoSelecionado.id, observacao: novaObs })
            const obsInput = document.getElementById('input-obs')
            obsInput.focus()
        }
    }

    const value = {
        eventosNA,
        setEventosNA,
        eventosEA,
        setEventosEA,
        eventosEE,
        setEventosEE,
        eventosEO,
        setEventosEO,
        setInfosEvento,
        eventoSelecionado,
        updateEventoSelecionado,
        removerEvento,
        removerEventoSelecionado,
        getLocalEventoSelecionado,
        updateObsIframe,
        finalizarEvento
    }
    return (
        <EventosContext.Provider value={value}>
            <div>
                {children}
            </div>
        </EventosContext.Provider>
    )
}
